import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-market-views',
  templateUrl: './market-views.component.html',
  styleUrls: ['./market-views.component.scss', './../ifacss.scss']
})
export class MarketViewsComponent implements OnInit {
  equityMarketOutlook: any;
  Deptmarketoutlook: any;
  Deptmarketoutlook1: any;
  Deptmarketoutlook2: any;

  //added by adarsh
  EMO_date: any;
  DMO_date: any;
  DMO1_date: any;
  DMO2_date: any;
  EMO_Time: any;
  DMO_Time: any;
  DMO1_Time: any;
  DMO2_Time: any;
  EMO_Header: any;
  DMO_Header: any;
  DMO1_Header: any;
  DMO2_Header: any;
  EMO_Desc: any;
  DMO_Desc: any;
  DMO1_Desc: any;
  DMO2_Desc: any;

  constructor(public sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.equityMarketOutlook = this.sanitizer.bypassSecurityTrustResourceUrl(
      sessionStorage.getItem('ihjt45h45=b')
    );
    this.Deptmarketoutlook = this.sanitizer.bypassSecurityTrustResourceUrl(
      sessionStorage.getItem('ihjt45h45=c')
    );
    this.Deptmarketoutlook1 = this.sanitizer.bypassSecurityTrustResourceUrl(
      sessionStorage.getItem('ihjt45h45=d')
    );
    this.Deptmarketoutlook2 = this.sanitizer.bypassSecurityTrustResourceUrl(
      sessionStorage.getItem('ihjt45h45=e')
    );
    this.EMO_date = sessionStorage.getItem('lkighty445dh==MK1');
    this.DMO_date = sessionStorage.getItem('lkighty445dh==MK2');
    this.DMO1_date = sessionStorage.getItem('lkighty445dh==MK3');
    this.DMO2_date = sessionStorage.getItem('lkighty445dh==MK4');
    this.EMO_Time = sessionStorage.getItem('lkighty445dh==MK5');
    this.DMO_Time = sessionStorage.getItem('lkighty445dh==MK6');
    this.DMO1_Time = sessionStorage.getItem('lkighty445dh==MK7');
    this.DMO2_Time = sessionStorage.getItem('lkighty445dh==MK8');
    this.EMO_Header = sessionStorage.getItem('lkighty445dh==MK9');
    this.DMO_Header = sessionStorage.getItem('lkighty445dh==MK10');
    this.DMO1_Header = sessionStorage.getItem('lkighty445dh==MK11');
    this.DMO2_Header = sessionStorage.getItem('lkighty445dh==MK12');
    this.EMO_Desc = sessionStorage.getItem('lkighty445dh==MK13');
    this.DMO_Desc = sessionStorage.getItem('lkighty445dh==MK14');
    this.DMO1_Desc = sessionStorage.getItem('lkighty445dh==MK15');
    this.DMO2_Desc = sessionStorage.getItem('lkighty445dh==MK16');
  }
}
